import Ghost from './Ghost'
export default Ghost